/**
/** @constant {string} BASE_COLOR_PICKER - Represents the base color picker input type. */
export const BASE_COLOR_PICKER = "baseColorPicker";

/** @constant {string} BUTTON_TOGGLE - Represents the button toggle input type. */
export const BUTTON_TOGGLE = "buttonToggle";

/** @constant {string} CHECKBOX - Represents the checkbox input type. */
export const CHECKBOX = "checkbox";

/** @constant {string} COLOR_PICKER - Represents the color picker input type. */
export const COLOR_PICKER = "colorPicker";

/** @constant {string} INPUT - Represents the input field type. */
export const INPUT = "input";

/** @constant {string} SELECT - Represents the select dropdown input type. */
export const SELECT = "select";

/** @constant {string} SWITCH - Represents the switch input type. */
export const SWITCH = "switch";
